import withStyles from '@material-ui/core/styles/withStyles';
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx';
import Accordion from 'components/Accordion/Accordion';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';;
import WaitDialog from 'conten/components/WaitDialog.jsx';
import Ocupacion from 'conten/principal/Ocupacion';
import React from 'react';
import { getDatosSolicitarListarOcupacionCiudad, getRegistroActualVehiculo } from './PrincipalApiClient';
import PlacaApi from 'conten/mensualidades/Placas/PlacasApiClient';
import { formatDateTimeReporte } from 'config/funciones/Comunes';
import Chip from "@material-ui/core/Chip";
import LinearProgress from "@material-ui/core/LinearProgress";
import { getHorasMinutosTranscurridos } from 'config/funciones/Comunes';
import { API_NOTIFICACIONES } from 'config/general/Configuracion';
import { ID_CUENTA } from 'config/general/Configuracion';
import MesaDeAyudaApiHelper from 'conten/mesaDeAyuda/MesaDeAyudaApiHelper';
import { FILA_BLANCA, FILA_GRIS } from "config/general/Configuracion";
import "../../assets/scss/components/linearProgressBar.scss";

var temporizador = null;
const MILI_SEGUNDOS_REFRESCAR = 1000 * 40 * 1; // 1 minuto
var temporizadorUbicacion = null;
class Principal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textAlertInfo: 'Un momento mientras completamos su solicitud.',
      datosOcupacionActual: [],
      timeNow: Date.now(), // ✅ timestamp
    };
  }

  componentWillUnmount() {
    if (temporizador) {
      clearInterval(temporizador);
    }
    temporizador = null;
    if (temporizadorUbicacion) clearInterval(temporizadorUbicacion);
    temporizadorUbicacion = null;

    if (this.watchId && navigator.geolocation) {
      navigator.geolocation.clearWatch(this.watchId);
    }
  }

  componentDidMount = () => {
    // 🔹 Paso 0: Cargar ID_USUARIO desde API si cuenta está disponible
    const cuentaId = localStorage.getItem(ID_CUENTA);
    if (cuentaId) {
      MesaDeAyudaApiHelper.obtenerIdUsuario()
        .then((usuarioData) => {
          if (usuarioData) {
            localStorage.setItem("ID_USUARIO", usuarioData);
          } else {
            console.error("❌ No se pudo obtener el ID del usuario.");
          }
        })
        .catch((error) => {
          console.error("❌ Error al cargar límites o ID de usuario:", error);
        });
    }

    // 🔹 Paso 1: Cargar placas al iniciar
    this.obtenerPlacas();

    // 🔹 Paso 2: Cancelar temporizador previo si existía
    if (temporizador) clearInterval(temporizador);
    temporizador = null;

    // 🔹 Paso 3: Obtener ocupación actual de zonas
    this.solicitarOcupacionActual();

    // 🔹 Paso 4: Iniciar temporizador para actualizaciones regulares
    temporizador = setInterval(() => {
      this.setState({ timeNow: Date.now() });
    }, 1000);

    // 🔹 Paso 5: Temporizador para consultar registros activos y ocupación
    if ("geolocation" in navigator) {
      this.watchId = navigator.geolocation.watchPosition(
        (pos) => {
          const { latitude, longitude } = pos.coords;
          const coords = { lat: latitude, lng: longitude };

          // 🔄 Guardar en estado para re-render
          this.setState({ ubicacionUsuario: coords }, () => {
            // Recalcular ocupación con nueva ubicación
            this.solicitarOcupacionActual();
            // Consultar registros activos con placas
            this.consultarRegistrosActualesParaPlacas();
          });
        },
        (error) => {
          console.warn("❌ Error al obtener ubicación en watch:", error);
        },
        { enableHighAccuracy: true, maximumAge: 0, timeout: 10000 }
      );
    }

    // 🔹 Paso 6: Registrar Service Worker y suscribirse a Push Notifications
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      navigator.serviceWorker.ready.then(async (registration) => {
        try {
          // const existingSubscription = await registration.pushManager.getSubscription();
          // if (existingSubscription) {

          //   await existingSubscription.unsubscribe(); // 🔥 Cancelar la anterior
          //   console.log("🧹 Suscripción anterior eliminada");
          // }

          const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: this.urlBase64ToUint8Array('BGXFAGCfHLjCsAkTMd0QA-C7m0LoeF5IIloYE5TDsrqA4lUhCZWWL2Dngi8TcZTIUAVyqofEQcMNPfXwTufhOBM')
          });

          console.log('📬 Suscripción Push:', subscription);

          await fetch(API_NOTIFICACIONES + '/v1/notificaciones/suscribirse', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              endpoint: subscription.endpoint,
              p256dh: btoa(String.fromCharCode(...new Uint8Array(subscription.getKey('p256dh')))),
              auth: btoa(String.fromCharCode(...new Uint8Array(subscription.getKey('auth')))),
              idUsuario: localStorage.getItem("ID_USUARIO"),
              cuenta: localStorage[ID_CUENTA]
            })
          });
        } catch (error) {
          console.error('❌ Error al suscribirse a notificaciones push:', error);
        }
      });
    }
  };

  urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
    const rawData = atob(base64);
    return new Uint8Array([...rawData].map(char => char.charCodeAt(0)));
  }


  mostrarNotificacion(titulo, cuerpo) {
    if (Notification.permission === 'granted' && navigator.serviceWorker) {
      navigator.serviceWorker.ready.then(function (registration) {
        registration.showNotification(titulo, {
          body: cuerpo,
          icon: '/icon-192.png',
          vibrate: [200, 100, 200],
          tag: Date.now().toString(), // ✅ Único para acumular
          renotify: false, // ✅ No reemplaza la anterior
          requireInteraction: false, // No requiere acción del usuario
          badge: '/icon-192.png',
          timestamp: Date.now(),
        });
      });
    }
  }

  solicitarOcupacionActual = async () => {
    this.setState({ isActivityIndicatorShown: true });

    try {
      const respuesta = await getDatosSolicitarListarOcupacionCiudad();

      let zonas = respuesta;
      const { ubicacionUsuario } = this.state;

      if (ubicacionUsuario) {
        zonas = zonas
          .map((zona) => {
            const distancia = this.calcularDistanciaKm(
              ubicacionUsuario.lat,
              ubicacionUsuario.lng,
              zona.latitud,
              zona.longitud
            );
            return { ...zona, distancia };
          })
          .sort((a, b) => a.distancia - b.distancia);
      }

      this.setState({
        datosOcupacionActual: zonas,
        isActivityIndicatorShown: false,
      });
    } catch (error) {
      console.error("Error al consultar ocupación por ciudad:", error);
      this.setState({ isActivityIndicatorShown: false });
    }
  };

  consultarRegistrosActualesParaPlacas = async () => {
    const { listaPlacas } = this.state;

    if (!listaPlacas || listaPlacas.length === 0) return;

    const resultados = [];

    // Hacer las consultas en paralelo, pero controladas
    await Promise.all(
      listaPlacas.map(async (placaObj) => {
        try {
          const registro = await getRegistroActualVehiculo(placaObj.placa);
          resultados.push({
            placa: placaObj.placa,
            tieneRegistro: registro && Object.keys(registro).length > 0,
            detalle: registro,
          });
        } catch (error) {
          console.warn(`Error consultando registro para ${placaObj.placa}:`, error);
          resultados.push({
            placa: placaObj.placa,
            tieneRegistro: false,
            detalle: null,
          });
        }
      })
    );
    this.setState({ registrosPorPlaca: resultados });
    return resultados;
  };

  respuestaSolicitarOcupacionActual = (_resp, cont) => {
    this.setState({ datosOcupacionActual: cont });
  };

  procesarContenidoPago = (conten, campo) => {
    var data = conten[campo];
    if (data.TOTAL < 1) {
      return '';
    }
    return (
      <>
        {data.GRATIS +
          ' Gratis ' +
          ((data.GRATIS / data.TOTAL) * 100).toFixed(2) +
          '%'}
        {<br />}
        {data.PAGO +
          ' Pagados ' +
          ((data.PAGO / data.TOTAL) * 100).toFixed(2) +
          '%'}
        {<br />}
        {data.REPORTADO +
          ' Reportados ' +
          ((data.REPORTADO / data.TOTAL) * 100).toFixed(2) +
          '%'}
      </>
    );
  };

  obtenerUbicacionUsuario() {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject("Geolocalización no soportada");
      } else {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            console.log("✔ Permiso de ubicación concedido");
            const coords = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            resolve(coords);
          },
          (error) => {
            reject("Error obteniendo ubicación: " + error.message);
          }
        );
      }
    });
  }

  calcularDistanciaKm(lat1, lon1, lat2, lon2) {
    const R = 6371; // km
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  async filtrarZonasPorProximidad(contenido, maxDistanciaKm = 5) {
    try {
      const { lat: userLat, lng: userLng } = await this.obtenerUbicacionUsuario();
      const zonasFiltradas = contenido
        .map((zona) => {
          const distancia = this.calcularDistanciaKm(userLat, userLng, zona.latitud, zona.longitud);
          return { ...zona, distancia };
        })
        .filter((zona) => zona.distancia <= maxDistanciaKm)
        .sort((a, b) => a.distancia - b.distancia);

      return zonasFiltradas;
    } catch (error) {
      console.warn(error);
      return contenido;
    }
  }

  emojiIcon = (emoji) => () => (
    <div
      style={{
        fontSize: '22px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 22,
        height: 22,
        lineHeight: 1,
      }}
    >
      {emoji}
    </div>
  );
  emojiIconRegistro = (emoji) => () => (
    <div
      style={{
        fontSize: '16px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 16,
        height: 16,
        lineHeight: 1,
      }}
    >
      {emoji}
    </div>
  );
  obtenerPlacas = () => {
    const paginacion = {
      limite: 50,
      actual: 1,
      filtro: null,
      orden: "placa",
      sentido: "ASC",
    };
    PlacaApi.listarPlacas(paginacion).then((respuesta) => {
      if (respuesta && respuesta.data && Array.isArray(respuesta.data.placas)) {
        this.setState({ listaPlacas: respuesta.data.placas }, () => {
          this.consultarRegistrosActualesParaPlacas().then(() => {
            const registrosConDatos = (this.state.registrosPorPlaca || []).filter((r) => r.tieneRegistro);
          });
        });
      } else {
        this.setState({ listaPlacas: [] });
      }

    }).catch((error) => {
      console.error("Error al obtener placas", error);
      this.setState({ listaPlacas: [] });
    });
  };

  getMinutosTranscurridos(inicio, fin) {
    const start = new Date(inicio).getTime();
    const end = typeof fin === "number" ? fin : new Date(fin).getTime();
    const diffMs = end - start;
    return diffMs / (1000 * 60);
  }


  renderRegistroActualPlaca = () => {
    const { registrosPorPlaca } = this.state;

    if (!registrosPorPlaca || registrosPorPlaca.length === 0) return null;

    const registrosConDatos = registrosPorPlaca.filter((r) => {
      if (!r.tieneRegistro) return false;

      const registro = r.detalle;

      // 🚫 Ocultar ventas prepago vencidas por más de 5 minutos
      if (
        registro.estado === 5 &&
        registro.fh_egreso &&
        this.state.timeNow > new Date(registro.fh_egreso).getTime() + 5 * 60 * 1000
      ) {
        return false;
      }

      return true;
    }).sort((a, b) => {
      const fechaA = new Date(a.detalle.fh_ingreso).getTime();
      const fechaB = new Date(b.detalle.fh_ingreso).getTime();
      return fechaB - fechaA; // descendente (más recientes primero)
    });

    if (registrosConDatos.length === 0) return null;

    return (
      <Accordion
        active={0}
        collapses={[
          {
            title: 'Tus registros',
            content: (
              <GridContainer>
                {registrosConDatos.map((registroItem, index) => {
                  const registro = registroItem.detalle;
                  return (
                    <GridContainer
                      key={`registro-${index}`}
                      container
                      alignItems="center"
                      style={{
                        backgroundColor: index % 2 == 0 ? FILA_BLANCA : FILA_GRIS,
                        padding: '10px',
                        borderBottom: '1px solid #ccc',
                        borderRadius: '5px',
                        margin: '0px',
                        width: '100%'
                      }}
                    >
                      <GridItem xs={12} sm={12} md={12} lg={12} >
                        <div style={{ display: "flex", alignItems: "center", marginBottom: "8px", justifyContent: "space-between" }}>
                          <h5 style={{ fontWeight: 'bold' }}>{registro.placa}</h5>
                          <Chip
                            label={registro.nombre_estado}
                            style={{
                              marginRight: "8px",
                              backgroundColor: registro.estado === 5 ? '#0D47A1' : '#FF6F00',
                              color: '#FFFFFF',
                            }}
                          />

                        </div>
                        {/* Barra de progreso para tiempo de gracia */}
                        {registro.estado === 0 && (
                          this.getMinutosTranscurridos(registro.fh_ingreso, this.state.timeNow) < registro.minutos_gracia_zona ? (
                            <div style={{ marginTop: "4px" }}>
                              <div style={{ fontSize: "0.9em", fontWeight: 500 }}>Tiempo de gracia ⏱️</div>
                              <LinearProgress
                                variant="determinate"
                                value={
                                  (this.getMinutosTranscurridos(registro.fh_ingreso, this.state.timeNow) * 100) /
                                  registro.minutos_gracia_zona
                                }
                                style={{ height: "16px", borderRadius: "12px", marginTop: "4px", marginBottom: "4px" }}
                                classes={{
                                  bar: "linear-progress-bar-gracia"
                                }}
                              />
                            </div>
                          ) : (
                            <div style={{ marginTop: "4px" }}>
                              <div style={{ fontSize: "0.9em", fontWeight: 500 }}>
                                Siguiente cobro ⏱️ (
                                {Math.ceil(60 - (this.getMinutosTranscurridos(registro.fh_ingreso, this.state.timeNow) % 60))}
                                min restantes
                                )
                              </div>
                              <LinearProgress
                                variant="determinate"
                                value={
                                  ((this.getMinutosTranscurridos(registro.fh_ingreso, this.state.timeNow) % 60) * 100) / 60
                                }

                                style={{ height: "16px", borderRadius: "12px", marginTop: "4px", marginBottom: "4px" }}
                                classes={{
                                  bar: "linear-progress-bar-rainbow-color"
                                }}
                              />
                            </div>
                          )
                        )}
                        {/* Solo para estado 'Venta Prepago' (por ejemplo, estado 2 o 3) */}
                        {registro.estado === 5 && registro.fh_egreso && (
                          <div style={{ marginTop: "8px" }}>
                            <div style={{ fontSize: "0.9em", fontWeight: 500 }}>Tiempo consumido 🔋</div>
                            <LinearProgress
                              variant="determinate"
                              value={
                                Math.min(
                                  (this.getMinutosTranscurridos(registro.fh_ingreso, this.state.timeNow) * 100) /
                                  this.getMinutosTranscurridos(registro.fh_ingreso, registro.fh_egreso),
                                  100)
                              }
                              color={
                                this.getMinutosTranscurridos(registro.fh_ingreso, this.state.timeNow) >= this.getMinutosTranscurridos(registro.fh_ingreso, registro.fh_egreso)
                                  ? "secondary"
                                  : "primary"
                              }
                              style={{ height: "16px", borderRadius: "12px", marginTop: "4px", marginBottom: "4px" }}
                              classes={{
                                bar: this.getMinutosTranscurridos(registro.fh_ingreso, new Date()) >= this.getMinutosTranscurridos(registro.fh_ingreso, registro.fh_egreso) ? "linear-progress-bar-red" : "linear-progress-bar-rainbow-color"
                              }}
                            />
                            {registro.estado === 5 && registro.fh_egreso &&
                              this.state.timeNow > new Date(registro.fh_egreso) && (
                                <div style={{
                                  marginTop: "6px",
                                  backgroundColor: "#ffebee",
                                  color: "#c62828",
                                  padding: "6px 10px",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  fontSize: "0.9em"
                                }}>
                                  ⚠️ Tiempo agotado – puede ser sancionado
                                </div>
                              )}
                          </div>
                        )}
                      </GridItem>
                      <GridItem xs={12} sm={12} md={5} lg={5}>
                        <div><b>{this.emojiIconRegistro('📍')()}</b> {registro.nombre_zona}</div>
                        <div><b>{this.emojiIconRegistro('🕒')()}</b> {formatDateTimeReporte(registro.fh_ingreso)}</div>
                        {registro.estado === 5 ?
                          <div style={{ fontSize: "1em", fontWeight: "bold", color: "black" }}>
                            <b>{this.emojiIconRegistro('⏰​')()}</b> {formatDateTimeReporte(registro.fh_egreso)}</div> : <></>}
                        <div><b>{this.emojiIconRegistro('👮‍♂️​')()}</b> {registro.nombre_promotor_ingreso}</div>
                        <div><b>{this.emojiIconRegistro('💲​')()}​​​</b> {registro.valor_h}</div>
                        <div style={{ fontSize: "1em", fontWeight: "bold", color: "black" }}><b>{this.emojiIconRegistro('⏳​')()}
                        </b> {getHorasMinutosTranscurridos(registro.fh_ingreso, this.state.timeNow)}</div>
                        {registro.estado === 5 ?
                          <div><b>{this.emojiIconRegistro('⏱️​')()}​</b> {registro.h_cobradas} {(registro.h_cobradas === 1 ? 'hora' : 'horas')}</div> : <></>}
                        {registro.estado === 5 ?
                          <div style={{ fontSize: "1em", fontWeight: "bold", color: "black" }}>
                            <b>{this.emojiIconRegistro('💰​')()}:</b> {registro.valor_cobrado}</div> : <></>}
                        {registro.estado === 0 && this.getMinutosTranscurridos(registro.fh_ingreso, this.state.timeNow) >= registro.minutos_gracia_zona && (() => {
                          const minutosDesdeGracia = this.getMinutosTranscurridos(registro.fh_ingreso, this.state.timeNow) - registro.minutos_gracia_zona;
                          const horasCobradas = Math.ceil(minutosDesdeGracia / 60);
                          const valorCobrado = horasCobradas * registro.valor_h;
                          return (
                            <div>
                              <div>
                                ⏱️ {horasCobradas} {horasCobradas === 1 ? 'hora' : 'horas'}
                              </div>
                              <div style={{ fontSize: "1em", fontWeight: "bold", color: "#4E342E" }}>
                                💰 {valorCobrado}
                              </div>
                            </div>
                          );
                        })()}
                      </GridItem>
                    </GridContainer>
                  );
                })}
              </GridContainer>
            )
          }
        ]}
      />
    );
  };

  render() {
    const { datosOcupacionActual } = this.state;
    // const { isActivityIndicatorShown } = this.state;
    // const registrosConDatos = (this.state.registrosPorPlaca || []).filter((r) => r.tieneRegistro);
    return (
      <div width="100%" padding="0" margin="0">
        {/* {isActivityIndicatorShown && (
          <WaitDialog text={this.state.textAlertInfo} />
        )} */}

        {this.renderRegistroActualPlaca()}
        <GridContainer>
          <Ocupacion
            // color='primary'
            // key={'OcupacionActual'}
            // fechaControl={null}
            // classCardIconTitle={classes.cardIconTitle}
            // titulo='Ocupación en las zonas'
            // icono={<PlaceIcon />}
            contenido={datosOcupacionActual}
            userLocation={this.state.ubicacionUsuario}
          />
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(extendedTablesStyle)(Principal);

